@if (value) {
    {{value}}
}
@else {
    <svg width="17" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="primary-1" d="M25.8626 2.22377L23.7376 0.138266C23.6531 0.0460885 23.5203 0 23.3995 0C23.2667 0 23.146 0.0460885 23.0614 0.138266L8.3311 14.299L2.97022 9.18314C2.87362 9.09096 2.75288 9.04488 2.63214 9.04488C2.5114 9.04488 2.39066 9.09096 2.29407 9.18314L0.144889 11.2341C-0.0482962 11.4184 -0.0482962 11.7065 0.144889 11.8908L6.90636 18.3432C7.34102 18.758 7.87228 19 8.31902 19C8.95895 19 9.51435 18.5506 9.71961 18.3663H9.73168L25.8747 2.88053C26.0437 2.68466 26.0437 2.3966 25.8626 2.22377V2.22377Z" />
    </svg>
}
